export interface Faq {
  question: string
  answer: string
}

export const faqs: Faq[] = [
  {
    question: 'Who is this system for?',
    answer:
      'Agronomists, agricultural technicians, crop consultants, commercial growers, horticulture professionals, and agronomy students who need organized visual references for plant nutrition assessment.',
  },
  {
    question: 'What types of nutritional problems does it cover?',
    answer:
      'The system covers essential nutrient deficiencies, nutrient excesses, toxicities, nutritional imbalances, soil-related nutrient availability problems, and crop-specific nutritional disorders.',
  },
  {
    question: 'Does it include visual nutrient deficiency identification?',
    answer:
      'Yes. The atlas includes annotated symptom references, leaf discoloration comparisons, deficiency identification charts, and crop-specific visual examples.',
  },
  {
    question: 'Does it include ready-to-use professional resources?',
    answer:
      'Yes. Field inspection forms, sampling records, nutrient management worksheets, monitoring templates, and professional reporting resources are included.',
  },
  {
    question: 'Is this suitable for beginners?',
    answer:
      'The system is designed primarily for agronomy students and agricultural professionals with foundational crop nutrition knowledge. It focuses on practical visual references rather than introductory plant biology.',
  },
  {
    question: 'Does it cover different crops and production systems?',
    answer:
      'Yes. It includes references for vegetables, fruits, cereals, legumes, greenhouse crops, and selected hydroponic production systems.',
  },
  {
    question: 'Is this a physical product?',
    answer: 'No. PLANT NUTRITION VISUAL ATLAS™ is a 100% digital professional reference system.',
  },
  {
    question: 'Is this a certification or training course?',
    answer:
      'No. It is a professional visual reference and assessment system intended to support agricultural learning and crop nutrition evaluations.',
  },
  {
    question: 'Does it replace laboratory testing or professional agronomic judgment?',
    answer:
      'No. Visual symptoms alone cannot always confirm a nutritional disorder. Appropriate soil and tissue testing, local agronomic guidance, and professional judgment remain essential.',
  },
  {
    question: 'How will I receive it?',
    answer: "You'll receive immediate digital access after purchase.",
  },
]
